/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OrganizationSite } from '../../models/organization-site';

export interface GetPlatformOrganisationsSites$Params {
}

export function getPlatformOrganisationsSites(http: HttpClient, rootUrl: string, params?: GetPlatformOrganisationsSites$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<OrganizationSite>>> {
  const rb = new RequestBuilder(rootUrl, getPlatformOrganisationsSites.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<OrganizationSite>>;
    })
  );
}

getPlatformOrganisationsSites.PATH = '/platform/organization-sites';
